(function () {
  const drawer = document.querySelector('[data-cart-drawer]');
  const cartItems = drawer && drawer.querySelector('[data-cart-items]');
  const cartTotal = drawer && drawer.querySelector('[data-cart-total]');
  const countNodes = document.querySelectorAll('[data-cart-count]');
  const money = (cents) => new Intl.NumberFormat('bs-BA', { style: 'currency', currency: 'BAM' }).format(cents / 100);
  const setCount = (count) => countNodes.forEach((node) => { node.textContent = count; });

  function renderCart(cart) {
    setCount(cart.item_count);
    if (!cart.item_count) {
      cartItems.innerHTML = '<p class="cart-empty">Tvoja korpa je trenutno prazna.</p>';
      cartTotal.textContent = '';
      return;
    }
    cartItems.innerHTML = cart.items.map((item) => `<div class="cart-row"><img src="${item.image || ''}" alt="${item.title}"><div><p><strong>${item.product_title}</strong></p><p>Veličina: ${item.variant_title || '—'}</p><p>${money(item.final_line_price)}</p><div class="cart-controls"><button type="button" data-cart-change data-line="${item.key}" data-quantity="${item.quantity - 1}" aria-label="Smanji količinu">−</button><span>${item.quantity}</span><button type="button" data-cart-change data-line="${item.key}" data-quantity="${item.quantity + 1}" aria-label="Povećaj količinu">+</button></div></div></div>`).join('');
    cartTotal.textContent = `Ukupno: ${money(cart.total_price)}`;
  }

  async function refreshCart(open) {
    if (!drawer) return;
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    renderCart(cart);
    if (open && !drawer.open) drawer.showModal();
  }

  document.querySelectorAll('[data-open-cart]').forEach((button) => button.addEventListener('click', () => refreshCart(true)));
  drawer?.querySelector('[data-close-cart]')?.addEventListener('click', () => drawer.close());
  drawer?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-change]');
    if (!button) return;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: button.dataset.line, quantity: Number(button.dataset.quantity) }) });
    refreshCart(false);
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (form.dataset.submitting === 'true') return;
    const button = form.querySelector('button[type="submit"]');
    form.dataset.submitting = 'true';
    if (button) button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (response.ok) await refreshCart(true);
    } finally {
      form.dataset.submitting = 'false';
      if (button) button.disabled = false;
    }
  }));

  const countdown = document.querySelector('[data-countdown]');
  if (countdown) {
    const deadline = Date.parse(countdown.dataset.deadline);
    const daysNode = countdown.querySelector('[data-countdown-days]');
    const hoursNode = countdown.querySelector('[data-countdown-hours]');
    const minutesNode = countdown.querySelector('[data-countdown-minutes]');
    const secondsNode = countdown.querySelector('[data-countdown-seconds]');
    const expiredNode = countdown.querySelector('[data-countdown-expired]');
    const offerNode = countdown.querySelector('.launch-banner__copy strong');
    const pad = (value) => String(value).padStart(2, '0');
    const updateCountdown = () => {
      const remaining = Math.max(0, deadline - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      if (daysNode) daysNode.textContent = String(days);
      if (hoursNode) hoursNode.textContent = pad(hours);
      if (minutesNode) minutesNode.textContent = pad(minutes);
      if (secondsNode) secondsNode.textContent = pad(seconds);
      if (remaining <= 0) {
        countdown.classList.add('is-ended');
        countdown.setAttribute('aria-label', 'Ponuda je završena');
        if (offerNode) offerNode.hidden = true;
        if (expiredNode) expiredNode.hidden = false;
      }
    };
    updateCountdown();
    const countdownInterval = window.setInterval(updateCountdown, 1000);
    window.addEventListener('pagehide', () => window.clearInterval(countdownInterval), { once: true });
  }

  document.querySelectorAll('[data-product-gallery]').forEach((galleryRoot) => {
    const photoButtons = Array.from(galleryRoot.querySelectorAll('[data-photo]'));
    const productImage = galleryRoot.querySelector('[data-product-image]');
    const imageNumber = galleryRoot.querySelector('[data-image-number]');
    const photoCache = photoButtons.map((button) => {
      const url = button.dataset.photoUrl;
      if (!url) return null;
      const image = new Image();
      image.decoding = 'async';
      image.src = url;
      return image;
    });
    let currentPhotoIndex = Math.max(photoButtons.findIndex((button) => button.getAttribute('aria-pressed') === 'true'), 0);
    function showProductPhoto(index) {
      if (!productImage || !photoButtons.length) return;
      const total = photoButtons.length;
      currentPhotoIndex = (index + total) % total;
      const button = photoButtons[currentPhotoIndex];
      const cachedImage = photoCache[currentPhotoIndex];
      if (cachedImage?.src) productImage.src = cachedImage.src;
      else if (button.dataset.photoUrl) productImage.src = button.dataset.photoUrl;
      if (button.dataset.photoAlt) productImage.alt = button.dataset.photoAlt;
      if (imageNumber) imageNumber.textContent = `${String(currentPhotoIndex + 1).padStart(2, '0')} — ${String(total).padStart(2, '0')}`;
      photoButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    }
    photoButtons.forEach((button, index) => button.addEventListener('click', () => showProductPhoto(index)));
    galleryRoot.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showProductPhoto(currentPhotoIndex - 1));
    galleryRoot.querySelector('[data-gallery-next]')?.addEventListener('click', () => showProductPhoto(currentPhotoIndex + 1));
  });

  const hero = document.querySelector('[data-hero]');
  const heroPhoto = document.querySelector('[data-hero-photo]');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  function heroMotion() {
    frame = 0;
    if (!hero || !heroPhoto || reduced.matches) { heroPhoto?.style.removeProperty('transform'); return; }
    const bounds = hero.getBoundingClientRect();
    const distance = Math.min(Math.max(-bounds.top, 0), bounds.height);
    const progress = bounds.height ? distance / bounds.height : 0;
    const strength = window.innerWidth <= 760 ? 0.24 : 0.38;
    heroPhoto.style.transform = `translate3d(0, ${(distance * strength).toFixed(2)}px, 0) scale(${(1 + progress * 0.16).toFixed(4)})`;
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(heroMotion); }
  window.addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  reduced.addEventListener('change', schedule);
  heroMotion();
}());
